import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { Acceleration } from '../../values';
import { SensorObject } from '../SensorObject';
/**
 * The linear acceleration sensor provides on each reading the acceleration applied to the device along all three axes, but without the contribution of gravity.
 * @category data
 */
let LinearAccelerationSensor = class LinearAccelerationSensor extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new Acceleration(), frequency, displayName);
  }
};
LinearAccelerationSensor = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, Acceleration, Number, String])], LinearAccelerationSensor);
export { LinearAccelerationSensor };